export const ARTICLE_TYPE_LABELS = {
  metric_concept: "Metrics & Concepts",
  investing_framework: "Investing Frameworks",
  product_help: "Product Help",
};

export const ARTICLE_TYPE_ORDER = ["metric_concept", "investing_framework", "product_help"];

export function articleTypeLabel(value) {
  return ARTICLE_TYPE_LABELS[value] || formatLearnLabel(value);
}

export function formatLearnLabel(value) {
  if (!value) return "Uncategorized";
  return String(value)
    .replace(/resources_reserves/g, "resources & reserves")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .replace(/\bAnd\b/g, "and")
    .replace(/\b&\b/g, "&");
}

export function formatLearnDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}
